// extracted by mini-css-extract-plugin
export default {"main":"ys9HD5A","bannerAndHeader":"N7WaOPj"};